/* eslint-disable camelcase */
import React, { ReactNode, useContext } from "react";
import { BrowserRouter, UNSAFE_LocationContext } from "react-router-dom";

/**
 * There should not be more than 1 router in an application,
 *  so if the router is already added by the host application (in cases of multiple pages) we need not add it.
 * In development mode, when we link the host application with dynamic-form, 2 routers will not be detected,
 *  so will have to add router in development mode.
 */

function RouterWrapper({ children }: { children: ReactNode }) {
  const locationContext = useContext(UNSAFE_LocationContext);

  // If there is no wrapping router || in dev env
  return !locationContext || process.env.NODE_ENV === "development" ? (
    <BrowserRouter>{children}</BrowserRouter>
  ) : (
    <> {children}</>
  );
}

export default RouterWrapper;
